import type { DetailedHTMLProps, VideoHTMLAttributes, SourceHTMLAttributes } from 'react';
import { useIntl } from 'react-intl';

export type VideoProps = DetailedHTMLProps<VideoHTMLAttributes<HTMLVideoElement>, HTMLVideoElement>
                       & DetailedHTMLProps<SourceHTMLAttributes<HTMLSourceElement>, HTMLSourceElement>
                       & {
                           labelId?: string;
                         };

const Video = ({src, labelId = 'locale', type = 'video/mp4', preload = 'metadata', ...props} : VideoProps) : JSX.Element => {

  const {locale, ...intl} = useIntl();

  const label = intl.formatMessage({ id: labelId });

  return (
    <video controls preload={preload} {...props}>
      <source src={src} type={type} />
      <track src={src} kind='captions' srcLang={locale} label={label} />
    </video>
  );
};

export default Video;